(function(){
  document.documentElement.classList.add('lt-js');
  function ready(fn){
    if(document.readyState !== 'loading'){ fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  function reduced(){
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function showAll(){
    var all = document.querySelectorAll('.lt-reveal');
    for(var i=0;i<all.length;i++){ all[i].classList.add('is-in'); }
  }
  function initReveal(){
    var els = document.querySelectorAll('.lt-reveal');
    if(!els.length) return;
    if(reduced() || !('IntersectionObserver' in window)){ showAll(); return; }
    var io = new IntersectionObserver(function(entries){
      for(var i=0;i<entries.length;i++){
        if(entries[i].isIntersecting){
          entries[i].target.classList.add('is-in');
          io.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    for(var i=0;i<els.length;i++){ io.observe(els[i]); }
    setTimeout(function(){
      var n = document.querySelectorAll('.lt-reveal');
      for(var j=0;j<n.length;j++){
        var r = n[j].getBoundingClientRect();
        if(r.top < window.innerHeight + 40){ n[j].classList.add('is-in'); }
      }
    }, 1400);
  }
  function initGallery(){
    var gals = document.querySelectorAll('.lt-gal');
    for(var g=0; g<gals.length; g++){
      (function(gal){
        var track = gal.querySelector('.lt-gal-track');
        var dots = gal.querySelectorAll('.lt-gal-dot');
        if(!track || !dots.length) return;
        var slides = track.querySelectorAll('.lt-gal-slide');
        for(var d=0; d<dots.length; d++){
          (function(idx){
            dots[idx].addEventListener('click', function(){
              if(slides[idx]){ track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
            });
          })(d);
        }
        var tick;
        track.addEventListener('scroll', function(){
          if(tick) return;
          tick = setTimeout(function(){
            tick = null;
            var w = track.clientWidth || 1;
            var i = Math.round(track.scrollLeft / w);
            for(var k=0;k<dots.length;k++){ dots[k].classList.toggle('is-on', k === i); }
          }, 70);
        });
      })(gals[g]);
    }
  }
  function initSticky(){
    var bar = document.querySelector('.lt-stickybar');
    if(!bar) return;
    var anchor = document.querySelector('.lt-pdp-form');
    function upd(){
      var show = true;
      if(anchor){
        var r = anchor.getBoundingClientRect();
        show = r.bottom < 0 || r.top > window.innerHeight;
      }
      bar.classList.toggle('is-on', show);
    }
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }
  function initVariants(){
    var roots = document.querySelectorAll('[data-lt-variants]');
    for(var r=0;r<roots.length;r++){
      (function(root){
        var data;
        var holder = root.querySelector('[data-lt-variant-json]');
        if(!holder) return;
        try { data = JSON.parse(holder.textContent); } catch(e){ return; }
        var idInput = root.querySelector('input[name="id"]');
        var priceNow = root.querySelector('[data-lt-price-now]');
        var priceWas = root.querySelector('[data-lt-price-was]');
        var btn = root.querySelector('[data-lt-add]');
        var inputs = root.querySelectorAll('.lt-pdp-opt-vals input');
        var track = root.querySelector('.lt-gal-track');
        var first = true;
        function money(cents, fmt){
          var v = (cents/100).toFixed(2).replace('.', ',');
          return v + ' ' + (fmt || '€');
        }
        function showImage(pos){
          if(first || !track || !pos || pos < 1) return;
          var slides = track.querySelectorAll('.lt-gal-slide');
          var s = slides[pos - 1];
          if(!s) return;
          track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: reduced() ? 'auto' : 'smooth' });
        }
        function sync(){
          var chosen = [];
          var groups = root.querySelectorAll('[data-lt-opt-index]');
          for(var i=0;i<groups.length;i++){
            var sel = groups[i].querySelector('input:checked');
            chosen.push(sel ? sel.value : null);
          }
          var found = null;
          for(var v=0; v<data.length; v++){
            var ok = true;
            for(var o=0;o<chosen.length;o++){
              if(chosen[o] !== null && data[v].options[o] !== chosen[o]){ ok = false; break; }
            }
            if(ok){ found = data[v]; break; }
          }
          if(!found) return;
          if(idInput) idInput.value = found.id;
          if(priceNow) priceNow.textContent = money(found.price, root.getAttribute('data-lt-cur'));
          if(priceWas){
            if(found.compare && found.compare > found.price){
              priceWas.textContent = money(found.compare, root.getAttribute('data-lt-cur'));
              priceWas.style.display = '';
            } else { priceWas.style.display = 'none'; }
          }
          if(btn){
            btn.disabled = !found.available;
            btn.textContent = found.available ? btn.getAttribute('data-lt-label') : btn.getAttribute('data-lt-sold');
          }
          showImage(found.img);
        }
        for(var i=0;i<inputs.length;i++){ inputs[i].addEventListener('change', sync); }
        sync();
        first = false;
      })(roots[r]);
    }
  }
  ready(function(){
    initReveal();
    initGallery();
    initSticky();
    initVariants();
  });
  window.addEventListener('load', function(){ setTimeout(function(){
    var n = document.querySelectorAll('.lt-reveal:not(.is-in)');
    for(var j=0;j<n.length;j++){
      var r = n[j].getBoundingClientRect();
      if(r.top < window.innerHeight + 40){ n[j].classList.add('is-in'); }
    }
  }, 300); });
})();
